module.exports = __webpack_public_path__ + "static/media/main.b02114ab.svg";